import React from 'react';
import { useCountUp } from './useCountUp';

const STATS = [
  { target: 8500, suffix: '+', label: 'Commercial Leases Analysed' },
  { target: 40, suffix: '+', label: 'Commercial Laws Covered' },
  { target: 100, suffix: '%', label: 'LTA 1954 Accuracy' },
  { target: 1800, suffix: '+', label: 'Leases Protected' },
];

function StatItem({ target, suffix, label }: { target: number; suffix: string; label: string }) {
  const { count, ref } = useCountUp(target, 2000);
  return (
    <div ref={ref} className="text-center">
      <div className="text-3xl sm:text-4xl font-bold text-white mb-1">
        {count.toLocaleString()}{suffix}
      </div>
      <p className="text-sm text-gray-400">{label}</p>
    </div>
  );
}

export function CommercialStatsBar() {
  return (
    <section className="py-16 sm:py-20 bg-gray-900 bg-dot-pattern relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-transparent to-gray-900" />
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 animate-on-scroll">
          <h3 className="text-xl font-bold text-white mb-2">Commercial Law AI Specialists</h3>
          <p className="text-sm text-gray-400">Trained on 8,500+ commercial leases and 40+ UK commercial laws</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-10">
          {STATS.map((s) => (
            <StatItem key={s.label} {...s} />
          ))}
        </div>
        <p className="text-center text-sm text-gray-500 max-w-2xl mx-auto leading-relaxed">
          Our specialist commercial AI model is trained exclusively on commercial lease agreements and legislation
          including LTA 1954, service charge law, dilapidations assessment, and rent review mechanisms.
        </p>
      </div>
    </section>
  );
}
